import * as sxStyles from '../AnalyticsDetails.styled'
import { Box, Stack } from '@mui/material'
import { Delivery } from '../../../../../types'
import {
  Body,
  Container,
} from '../../../../Shipment/pages/IncomingDeliveriesDetails/components/ConsistencyResult/ConsistencyResult.styled'
import { CardLoader, CardTitle } from '../../../../../components'
import { DeliveryStatus } from '../../../../../components/features/DeliveryStatus/DeliveryStatus'

type AnalysisConsistencyProps = {
  delivery?: Delivery
  isDeliveryLoading?: boolean
}

export const AnalysisConsistencySection = ({
  delivery,
  isDeliveryLoading,
}: AnalysisConsistencyProps) => (
  <Stack sx={sxStyles.analysisStatusSectionContainer} flex={1}>
    <Container>
      <Box px="16px">
        <CardTitle title="Consistency" />
      </Box>
      <Body>
        {isDeliveryLoading ? (
          <CardLoader />
        ) : (
          <DeliveryStatus {...delivery?.consistency} />
        )}
      </Body>
    </Container>
  </Stack>
)
